module.exports = __webpack_public_path__ + "img/potenza_sport.9fc5c49b.png";